<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">New Purchase Requisition</h4>
                <p class="text-subtitle-1">Purchase Requisition Creation Form</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <PurchaseRequistionForm 
                    ref="requistionForm"
                    @submit="handleSubmit"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn block color="primary" @click="handleSave" :loading="loading">
                    <v-icon left>mdi-content-save</v-icon>
                    save
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn block depressed @click="handleCancel">
                    cancel
                </v-btn>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert" />
    </v-container>

</template>

<script>
import permissions from './../../data/permissions';
import { mapActions, mapGetters } from 'vuex';
import PurchaseRequistionForm from './../../components/purchase/PurchaseRequisitionForm.vue'
import PAlert from './../../components/common/PAlert'
import { v4 as uuid } from 'uuid';

export default {
    name: "PurchaseRequisitionCreateView",
    components: {
        PurchaseRequistionForm,
        PAlert
    },
    data() {
        return {
            loading: false,
            alert: {
                value: false,
                title: "Alert",
                content: "are you sure",
                callback: null
            },
            perm: permissions,
            idempotentKey: null
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        }),
    },
    methods: {
        ...mapActions({
            snackbar: "ui/snackbar/show",
            create: "purchase/requisition/create"
        }),
        save(){
            this.$refs.requistionForm.submit()
        },
        handleSave() {
            this.alert = {...this.alert, content: "Are you sure you want to save", value: true, callback: this.save}
        },
        handleAddLine() {
            this.$refs.requistionForm.addLine()
        },
        handleSubmit(form) {
            this.loading = true;
            this.create({...form, idempotentKey: this.idempotentKey}).then(response => {
                this.$router.replace({ name: "PurchaseRequisitionDisplay", params: { id: response.data.id }})
                this.snackbar({text: 'Purchase Requisition Create', color: "success"})
            }).catch(error => {
                let message = error.response ? error.response.data.message : error; 
                this.snackbar({ text: message, color: "error"})
            }).finally(() => {
                this.loading = false
            })
        },
        handleList() {
            this.$router.push({ name: "PurchaseRequisitionList"})
        },
        handleCancel() {
            this.$router.back()
        }

    },
    mounted() {
        this.idempotentKey = uuid();
    },

}
</script>

<style>

</style>